import React, { useState, useCallback } from 'react';
import { ReferenceInput, AutocompleteInput } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

import LugarQuickCreateButton from './LugarQuickCreateButton';

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center'
  }
});

const LugarReferenceInput = props => {
  const classes = useStyles();
  const [version, setVersion] = useState(0);
  const handleChange = useCallback(() => setVersion(version + 1), [version]);

  return (
    <div className={classes.root}>
      <ReferenceInput key={version} {...props} sort={{field: 'nombre', order: 'ASC'}}>
        <AutocompleteInput optionText={record => record?.provincia ? `${record.nombre}, ${record.provincia}` : record?.nombre ? `${record.nombre}` : ''} />
      </ReferenceInput>

      <LugarQuickCreateButton onChange={handleChange} />
    </div>
  );
};

export default LugarReferenceInput;
